module.exports = __webpack_public_path__ + "img/globus.9dd01a24.png";